import React, { useState, useEffect, createContext } from "react";
import ConnectionsClient from "../services/ConnectionsClient";
import { useTranslation } from "react-i18next";
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	alpha,
} from "@mui/material";

export const CreatorContext = createContext({
	creator: null,
	creatorCategories: null,
	creatorServices: null,
	creatorWorkers: null,
	creatorUser: null,
	pathId: null,
	isWeb: null,
});

export const CreatorProvider = ({ children, setFont, setMainColor }) => {
	const { t, i18n } = useTranslation();
	const [openDialog, setOpenDialog] = useState(false);

	const creatorCategoriesBarber = [
		{
			id: 1,
			title: "Corte de Cabello", // t("categories.category1")
		},
		{
			id: 2,
			title: "Barba y Afeitado", // t("categories.category2")
		},
		{
			id: 3,
			title: "Peinados", // t("categories.category3")
		},
		{
			id: 4,
			title: "Coloración y Mechas", // t("categories.category4")
		},
		{
			id: 5,
			title: "Tratamientos Capilares", // t("categories.category5")
		},
	];

	const creatorCategoriesTrainer = [
		{
			id: 1,
			title: "Sesiones personalizadas",
		},
		{
			id: 2,
			title: "Sesiones a domicilio",
		},
		{
			id: 3,
			title: "Recuperación y Wellness",
		},
		{
			id: 4,
			title: "Nutrición",
		},
	];

	const creatorWorkers = [
		{
			id: 1,
			name: "Alex",
			workingHours: [
				{
					weekday: 1,
					from: "09:00",
					to: "17:00",
				},
				{
					weekday: 2,
					from: "09:00",
					to: "17:00",
				},
				{
					weekday: 3,
					from: "09:00",
					to: "17:00",
				},
				{
					weekday: 4,
					from: "09:00",
					to: "17:00",
				},
				{
					weekday: 5,
					from: "09:00",
					to: "17:00",
				},
			],
			workerHolidays: [],
			workerAppointments: [],
		},
	];

	const creatorBarber = [
		// Corte de Cabello
		{
			id: 1,
			title: "Corte de Cabello Básico (Unisex)", // t("services.service1")
			price: 20,
			duration: 30,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 2,
			title: "Corte de Cabello Premium (Unisex)", // t("services.service2")
			price: 35,
			duration: 45,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 3,
			title: "Corte de Puntas (Unisex)", // t("services.service3")
			price: 15,
			duration: 20,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 4,
			title: "Corte de Cabello Masculino", // t("services.service4")
			price: 20,
			duration: 30,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 5,
			title: "Corte Fade o Degradado", // t("services.service5")
			price: 25,
			duration: 40,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		// Barba y Afeitado
		{
			id: 6,
			title: "Arreglo de Barba", // t("services.service6")
			price: 15,
			duration: 20,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 7,
			title: "Afeitado Clásico con Navaja", // t("services.service7")
			price: 25,
			duration: 30,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 8,
			title: "Corte de Cabello + Arreglo de Barba", // t("services.service8")
			price: 30,
			duration: 60,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 9,
			title: "Coloración de Barba", // t("services.service9")
			price: 25,
			duration: 25,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
		},
		// Peinados
		{
			id: 10,
			title: "Peinado Sencillo (Unisex)", // t("services.service10")
			price: 25,
			duration: 30,
			categoryId: 3,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 11,
			title: "Peinado para Eventos Especiales (Unisex)", // t("services.service11")
			price: 45,
			duration: 60,
			categoryId: 3,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 12,
			title: "Peinado con Trenzas (Unisex)", // t("services.service12")
			price: 30,
			duration: 45,
			categoryId: 3,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [
				{
					id: 1,
					title: "Peinado Trenza - Una Trenza", // t("serviceOptions.serviceOption3")
					price: 30,
					duration: 45,
				},
				{
					id: 2,
					title: "Peinado Trenza - Trenzas Complejas", // t("serviceOptions.serviceOption4")
					price: 45,
					duration: 60,
				},
			],
		},
		// Coloración y Mechas
		{
			id: 13,
			title: "Coloración Completa (Unisex)", // t("services.service13")
			price: 60,
			duration: 90,
			categoryId: 4,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [
				{
					id: 1,
					title: "Tinte normal", // t("serviceOptions.serviceOption1")
					price: 50,
					duration: 90,
				},
				{
					id: 2,
					title: "Tinte eco", // t("serviceOptions.serviceOption2")
					price: 90,
					discount: 10,
					duration: 120,
				},
			],
		},
		{
			id: 14,
			title: "Mechas o Reflejos (Unisex)", // t("services.service14")
			price: 50,
			duration: 90,
			categoryId: 4,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
		},
		{
			id: 15,
			title: "Corrección de Color (Unisex)", // t("services.service15")
			price: 80,
			duration: 120,
			categoryId: 4,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		// Tratamientos Capilares
		{
			id: 16,
			title: "Tratamiento Hidratante (Unisex)", // t("services.service16")
			price: 40,
			duration: 45,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 17,
			title: "Tratamiento de Keratina (Unisex)", // t("services.service17")
			price: 100,
			duration: 120,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 18,
			title: "Tratamiento Reparador (Unisex)", // t("services.service18")
			price: 50,
			duration: 60,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 19,
			title: "Lavado y Secado (Unisex)", // t("services.service19")
			price: 15,
			duration: 20,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 20,
			title: "Extensiones (Unisex)", // t("services.service20")
			price: 150,
			duration: 180,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 21,
			title: "Facial Relajante para Hombres", // t("services.service21")
			price: 40,
			duration: 45,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 22,
			title: "Exfoliación e Hidratación Facial (Unisex)", // t("services.service22")
			price: 30,
			duration: 30,
			categoryId: 5,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
	];

	const creatorTrainer = [
		{
			id: 1,
			title: "Sesión de Entrenamiento de Fuerza", // Corte de Cabello Básico (Unisex)
			price: 90,
			duration: 30,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 2,
			title: "Entrenamiento HIIT", // Corte de Cabello Premium (Unisex)
			price: 79,
			duration: 60,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 3,
			title: "Clase corta en gimnasio", // Corte de Puntas (Unisex)
			price: 35,
			duration: 30,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 4,
			title: "Programa Pérdida", // Corte de Cabello Masculino
			price: 68,
			duration: 60,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 5,
			title: "Rehabilitación", // Corte Fade o Degradado
			price: 30,
			duration: 30,
			categoryId: 1,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 6,
			title: "Sesión de Entrenamiento de Fuerza", // Corte de Cabello Básico (Unisex)
			price: 90,
			duration: 30,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 7,
			title: "Entrenamiento HIIT", // Corte de Cabello Premium (Unisex)
			price: 79,
			duration: 60,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 8,
			title: "Clase corta a domicilio", // Corte de Puntas (Unisex)
			price: 35,
			duration: 30,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 9,
			title: "Programa Pérdida", // Corte de Cabello Masculino
			price: 68,
			duration: 60,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 10,
			title: "Rehabilitación", // Corte Fade o Degradado
			price: 30,
			duration: 30,
			categoryId: 2,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 11,
			title: "Sesión de relajación", // Corte Fade o Degradado
			price: 30,
			duration: 30,
			categoryId: 3,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
		{
			id: 11,
			title: "Programa personalizado de nutrición", // Corte Fade o Degradado
			price: 30,
			duration: 30,
			categoryId: 4,
			workers: creatorWorkers,
			serviceHours: creatorWorkers[0].workingHours,
			serviceOptions: [],
		},
	];

	const creatorUser = {
		id: 1,
		name: "Taylor",
		phone: "555555555",
		email: "taylor@applaby.com",
		phonePrefix: "+34",
		points: 0,
		activatedAt: new Date().toISOString(),
	};

	const [creator, setCreator] = useState(null);
	const [pathId, setPathId] = useState(null);
	const [isWeb, setIsWeb] = useState(false);
	const [firstTime, setFirstTime] = useState(true);

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	const getFirstPathPart = () => {
		const url = new URL(window.location.href);
		// Get the base path (path only)
		const pathname = url.pathname; // "/first-part/other/segments"
		// Split by slashes and filter out empty parts
		const parts = pathname.split("/").filter((part) => part);
		const firstPart = parts.length > 0 ? parts[0] : null;
		return firstPart;
	};

	useEffect(() => {
		const baseURL = "https://api.applaby.com";
		const initApp = async () => {
			const firstPart = getFirstPathPart();
			if (firstPart !== "applaby-iframe") {
				setPathId(firstPart);
				ConnectionsClient.defaults.baseURL = `${baseURL}/${firstPart}/iframe`;
				const res = await ConnectionsClient.get("/iframe-creator", {
					params: {
						path: firstPart,
					},
				});
				if (res.data && res.data.mainColor) {
					setCreator(res.data);
					i18n.changeLanguage(res.data.language);
					setFont(res.data.fontFamily);
					setMainColor(res.data.mainColor);
				}
				// TO DO: change
				setIsWeb(false);
			} else {
				ConnectionsClient.defaults.baseURL = `${baseURL}/iframe`;
				const sendMessage = () => {
					// Define the message to send
					const message = { data: "GET_DATA" };

					// Send the message to the iframe, specifying the target origin (the iframe's domain)
					window.parent.postMessage(
						message,
						"https://creator.applaby.com"
						//"http://localhost:3003"
					);
				};

				setTimeout(() => {
					sendMessage();
				}, 1);
			}
		};

		initApp();
	}, [setFont, setMainColor, i18n]);

	useEffect(() => {
		if (creator && creator.isCreator && firstTime) {
			setOpenDialog(true);
			setFirstTime(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [creator, firstTime]);

	useEffect(() => {
		const firstPart = getFirstPathPart();
		if (firstPart === "applaby-iframe") {
			// Define the allowed origins
			const allowedOrigins = [
				"http://localhost:3003",
				"https://creator.applaby.com",
			];

			// Add an event listener for messages
			window.addEventListener(
				"message",
				function (event) {
					// Check if the message is from one of the allowed domains
					if (allowedOrigins.includes(event.origin)) {
						// Process the message
						console.log("Message received from allowed domain:", event.data);
						if (event.data.data && event.data.data.mainColor) {
							setCreator({ ...event.data.data, isCreator: true });
							i18n.changeLanguage(event.data.data.language);
							setFont(event.data.data.fontFamily);
							setMainColor(event.data.data.mainColor);
						}
					} else {
						// Ignore messages from unauthorized domains
						console.warn("Message from unauthorized domain:", event.origin);
					}
				},
				false
			);
		}
	}, [setFont, setMainColor, i18n]);

	return (
		<CreatorContext.Provider
			value={{
				creator,
				creatorCategories:
					creator?.app?.appSubtype === "Trainer"
						? creatorCategoriesTrainer
						: creatorCategoriesBarber,
				creatorServices:
					creator?.app?.appSubtype === "Trainer"
						? creatorTrainer
						: creatorBarber,
				creatorWorkers,
				creatorUser,
				isWeb,
				pathId,
			}}
		>
			<>
				{!creator ? (
					<Box
						sx={{
							padding: "20px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<CircularProgress sx={{ color: "gray" }} size={12} />
					</Box>
				) : (
					children
				)}
				<Dialog
					open={openDialog}
					onClose={handleCloseDialog}
					sx={{
						"& .MuiPaper-root": {
							border:
								"1px solid " + alpha(creator?.fontColor ?? "#000000", 0.3),
							borderRadius: 2,
							overflow: "hidden",
						},
					}}
				>
					<DialogTitle
						sx={{
							backgroundColor: creator?.backgroundColor || "#ffffff",
							color: creator?.fontColor || "#000000",
							fontWeight: "bold",
						}}
					>
						{t("creatorTitle")}
					</DialogTitle>
					<DialogContent
						sx={{
							backgroundColor: creator?.backgroundColor || "#ffffff",
							color: creator?.fontColor || "#000000",
						}}
					>
						<Typography>{t("creatorDesc")}</Typography>
						<br />
						<br />
						<Typography>{t("creatorDesc2")}</Typography>
					</DialogContent>
					<DialogActions
						sx={{
							display: "flex",
							justifyContent: "flex-end",
							padding: "16px",
							flexDirection: {
								xs: "column", // Para pantallas pequeñas (se apilan verticalmente)
								sm: "row", // Para pantallas grandes (se alinean horizontalmente)
							},
							backgroundColor: creator?.backgroundColor || "#ffffff",
							color: creator?.fontColor || "#000000",
							gap: 1, // Añadir espacio entre botones
						}}
					>
						<Button
							variant="contained"
							color="primary"
							onClick={() => {
								setOpenDialog(false);
							}}
							sx={{ width: { xs: "100%", sm: "auto" } }}
						>
							{t("creatorButton")}
						</Button>
					</DialogActions>
				</Dialog>
			</>
		</CreatorContext.Provider>
	);
};
